module.exports = __webpack_public_path__ + "img/m.89699915.jpg";